import { useAvailableElevatedStock } from "@coworker/app/src/hooks/useAvailableElevatedStock";
import { parseProduct } from "@coworker/app/src/services/products.service";
import { useItemExpectedDelivery } from "../../../shared/hooks/item/useItemExpectedDelivery";
import { ProductCardPresentation } from "./ProductCardPresentation";
import { Item } from "../../../shared/types/item";
import { useParams } from "react-router";

interface ProductCardProps {
  product: Item;
  setSearchHistory: (value: string[]) => void;
  searchHistory: string[];
  handleProductClick: (product: Item) => void;
  className?: string | undefined;
}

export const ProductCard = ({
  product,
  setSearchHistory,
  searchHistory,
  handleProductClick,
  className,
}: ProductCardProps) => {
  const [short_id] = parseProduct(product.no);
  const full_id = product.type + short_id;
  const {
    available,
    elevated,
    color,
    loading: isStockLoading,
  } = useAvailableElevatedStock(full_id);
  const { data: itemDeliveryData, isLoading: isDeliveryDataLoading } =
    useItemExpectedDelivery(short_id);

  const { type } = useParams<{ type: string }>();
  const isGlobalSearch = type === "global";
  const handleProductClickWrapper = () => {
    if (isGlobalSearch) {
      const normalizedName = product.name.toLowerCase();
      if (normalizedName) {
        setSearchHistory([
          normalizedName,
          ...searchHistory
            .filter((name) => name !== normalizedName)
            .slice(0, 9),
        ]);
      }
    }
    handleProductClick(product);
  };

  return (
    <ProductCardPresentation
      product={product}
      available={available}
      elevated={elevated}
      color={color}
      isStockLoading={isStockLoading}
      itemDeliveryData={itemDeliveryData}
      isDeliveryDataLoading={isDeliveryDataLoading}
      handleProductClick={handleProductClickWrapper}
      className={className}
    />
  );
};
